import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    team: []
};

const team2Slice = createSlice({
    name: 'team2',
    initialState,
    reducers: {
        addPokemon: (state, action) => {
            if (!state.team.includes(action.payload) && state.team.length < 6) {
                state.team.unshift(action.payload);
            }
        },
        removePokemon: (state, action) => {
            const nameToRemove = action.payload;
            const index = state.team.indexOf(nameToRemove);
            if (index !== -1) {
                state.team.splice(index, 1);
            }
        },
        removeAll: (state) => {
            state.team = [];
        },
        shuffle: (state) => {
            state.team.sort(() => Math.random() - 0.1);

        }
    }
});

export const { addPokemon, removePokemon, removeAll,shuffle } = team2Slice.actions;
export default team2Slice.reducer;
